<template>
  <v-app class="app-tabela">
    <div class="box mt-0 mb-5">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar por nome da equipe, CNES ou INE"
            class="input-bottom"
            single-line
            hide-details
          />
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="indexedItems"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :search="search"
          :item-class="getRowColor"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :page="currentPage"
          item-key="index"
          show-expand
          :single-expand="true"
          :expanded.sync="expanded"
          @pagination="getPagination"
          @item-expanded="onItemExpanded"
          class="elevation-1"
        >
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec"></div>
            <span class="paginacao">
              {{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} equipes
            </span>
          </template>

          <template v-slot:item.classificacao="{ item }">
            {{ item.classificacao }}
            <span
              v-b-tooltip.html.hover
              :title="getTextoClassificacaoTooltip(item)"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>Indicador</th>
                    <th>Peso</th>
                    <th>Numerador</th>
                    <th>Denominador</th>
                    <th>Pontuação</th>
                    <th>Nota</th>
                    <th>Classificação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(ind, idx) in item.all_indicadores || []"
                    :key="idx"
                  >
                    <td>
                      <router-link :to="linksCards(ind.indicador)">
                        {{ ind.ds_indicador ?? '-' }}
                      </router-link>
                    </td>
                    <td>{{ ind.peso ?? '-' }}</td>
                    <td>
                      <div v-if="ind.indicador == 47">-</div>
                      <div v-else>
                        {{ ind.numerador ?? '-' }}
                        <span
                          v-if="ind.numerador != null"
                          v-b-tooltip.html.hover
                          :title="getTooltipsTexts(ind.indicador).numerador"
                          class="icon-tooltip"
                        >
                          <i class="icofont-info-circle"></i>
                        </span>
                      </div>
                    </td>
                    <td>
                      {{ ind.denominador ?? '-' }}
                      <span
                        v-if="ind.denominador != null"
                        v-b-tooltip.html.hover
                        :title="getTooltipsTexts(ind.indicador).denominador"
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </td>
                    <td>
                      {{ ind.resultado ?? '-' }}
                      <span
                        v-if="ind.resultado != null"
                        v-b-tooltip.html.hover
                        :title="getTooltipsTexts(ind.indicador).resultado"
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </td>
                    <td>{{ ind.nota ?? '-' }}</td>
                    <td>
                      {{ ind.classificacao ?? '-' }}
                      <span
                        v-if="ind.classificacao != null"
                        v-b-tooltip.html.hover
                        v-bind:title="getTextoClassificacaoInternaTooltip(ind)"
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>

          <template v-slot:progress>
            <v-progress-linear color="blue" :height="10" indeterminate />
          </template>

          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>

          <template v-slot:no-results>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import TextoClassificacaoIndicador from '@/components/utils/TextoClassificacaoIndicador'

export default {
  name: 'EquipesDataTable',
  components: {
    TextoClassificacaoIndicador,
  },
  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      search: '',
      currentPage: 1,
      expanded: [],
      headers: [
        { text: 'CNES', align: 'start', filterable: true, value: 'nu_cnes' },
        { text: 'UBS', align: 'start', filterable: true, value: 'no_ubs' },
        { text: 'INE', align: 'start', filterable: true, value: 'ine' },
        {
          text: 'Equipe',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        {
          text: 'Nota',
          align: 'start',
          sortable: false,
          filterable: false,
          value: 'nota',
        },
        {
          text: 'Classificação',
          align: 'start',
          sortable: false,
          filterable: false,
          value: 'classificacao',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  computed: {
    indexedItems() {
      return this.items.map((it, idx) => ({
        index: idx,
        ...it,
      }))
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} p Dados da paginação
     */
    getPagination(p) {
      this.currentPage = p.page
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} ctx Contexto do item expandido
     */
    onItemExpanded(ctx) {},

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     */
    getRowColor(item) {},

    getTextoClassificacaoTooltip(item) {
      const lista = this.$store.state.regrasIndicadoresAps || []

      const classificacao = String(item.classificacao || '').toUpperCase()

      const itens =
        classificacao === 'REGULAR'
          ? lista.filter(
              (i) =>
                i.id_indicador == item.indicador &&
                String(i.classificacao || '').toUpperCase() === classificacao
            )
          : [
              lista.find(
                (i) =>
                  i.id_indicador == item.indicador &&
                  String(i.classificacao || '').toUpperCase() === classificacao
              ),
            ].filter(Boolean)

      if (!itens.length) return null

      const partesParametro = itens
        .map((item) => {
          const partes = []

          if (item.sinal_min && item.min_val) {
            partes.push(`${item.sinal_min} ${item.min_val}`)
          }

          if (item.sinal_max && item.max_val) {
            partes.push(`${item.sinal_max} ${item.max_val}`)
          }

          // Se vierem os dois no mesmo registro, junta com " e "
          return partes.join(' e ')
        })
        .filter(Boolean)

      const parametro = partesParametro.join(' e ')

      const ref = itens[0]

      return `Peso: ${ref.peso} <br>
              Nota: ${item.nota} ${parametro} <br>
              Classificação: ${ref.classificacao} `
    },

    getTextoClassificacaoInternaTooltip(item) {
      const lista = this.$store.state.regrasIndicadoresAps || []

      const classificacao = String(item.classificacao || '').toUpperCase()

      const itens =
        classificacao === 'REGULAR'
          ? lista.filter(
              (i) =>
                i.id_indicador == item.indicador &&
                String(i.classificacao || '').toUpperCase() === classificacao
            )
          : [
              lista.find(
                (i) =>
                  i.id_indicador == item.indicador &&
                  String(i.classificacao || '').toUpperCase() === classificacao
              ),
            ].filter(Boolean)

      if (!itens.length) return null

      const partesParametro = itens
        .map((item) => {
          const partes = []

          if (item.sinal_min && item.min_val) {
            partes.push(`${item.sinal_min} ${item.min_val}`)
          }

          if (item.sinal_max && item.max_val) {
            partes.push(`${item.sinal_max} ${item.max_val}`)
          }

          // Se vierem os dois no mesmo registro, junta com " e "
          return partes.join(' e ')
        })
        .filter(Boolean)

      const parametro = partesParametro.join(' e ')

      const ref = itens[0]

      return `Peso: ${ref.peso} <br> Pontuação: ${item.resultado} ${parametro} <br> Classificação: ${ref.classificacao} (${ref.val_classificacao}) <br> Nota: ${ref.nota} (Peso * Classificação)`
    },

    getTooltipsTexts(idIndicador) {
      const nomesIndicadores = {
        46: {
          numerador:
            'Total de atendimentos por demanda programada (consulta agendada programada; cuidado continuado; e consulta agendada).',
          denominador:
            'Total de atendimentos por todos os tipos de demandas (espontâneas e programadas).',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 10 ou > 70',
            'Suficiente: > 10 e <= 30',
            'Bom: > 30 e <= 50',
            'Ótimo: > 50 e <= 70',
          ],
        },
        51: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento do desenvolvimento infantil.',
          denominador:
            'Total de crianças com idade igual a 2 (dois) anos completos.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        52: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento de uma pessoa gestante e puérpera.',
          denominador:
            'Total de mulheres com encerramento de puerpera no quadrimestre avaliado.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        48: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento da pessoa com diabetes.',
          denominador: 'Total de pessoas com diabetes.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        50: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento da pessoa com hipertensão arterial.',
          denominador: 'Total de pessoas com hipertensão arterial.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        49: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento da pessoa idosa.',
          denominador: 'Total de pessoas idosas.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        47: {
          numerador:
            'Somatório da(s) boa(s) prática(s) aplicável(is) para a mulher.',
          denominador: 'Total de mulheres elegíveis na faixa etária.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        44: {
          numerador:
            'Total de atendimentos individuais e coletivos realizados pela eMulti no quadrimestre avaliado.',
          denominador: 'Total de pessoas atendidas no quadrimestre avaliado.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 1',
            'Suficiente: > 1 e <= 2',
            'Bom: > 2 e <= 3',
            'Ótimo: > 3',
          ],
        },
        45: {
          numerador:
            'Total de ações compartilhadas realizadas pela eMulti no quadrimestre avaliado.',
          denominador: 'Total de ações realizadas pela eMulti.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 1',
            'Suficiente: > 1 e <= 2,5',
            'Bom: > 2,5 e <= 5',
            'Ótimo: > 5',
          ],
        },
        38: {
          numerador:
            'Total de pessoas com atendimentos de primeira consulta odontológica programática.',
          denominador: 'Total de pessoas vinculadas à equipe.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 1',
            'Suficiente: > 1 e <= 3',
            'Bom: > 3 e <= 5',
            'Ótimo: > 5',
          ],
        },
        43: {
          numerador: 'Total de pessoas com tratamento odontológico concluído.',
          denominador:
            'Total de pessoas com primeira consulta odontológica programada.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            ' Ótimo: > 75 e <= 100',
          ],
        },
        39: {
          numerador: 'Total de exodontias.',
          denominador:
            'Total de procedimentos clínicos individuais preventivos, curativos e exodontias realizados.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: < 8 ou >= 14',
            'Suficiente: >= 12 e < 14',
            'Bom: >= 10 e < 12',
            'Ótimo: >= 8 e < 10',
          ],
        },
        42: {
          numerador:
            'Total de pessoas participantes da ação coletiva de escovação dental supervisionada realizada em crianças com idade entre 6 e 12 anos.',
          denominador: 'Total de pessoas vinculadas à equipe.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 0,25',
            'Suficiente: > 0,25 e <= 0,5',
            'Bom: > 0,5 e <= 1',
            'Ótimo: > 1',
          ],
        },
        40: {
          numerador:
            'Total de procedimentos odontológicos individuais preventivos.',
          denominador:
            'Todos os procedimentos odontológicos individuais registrados.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: < 40 ou > 85',
            'Suficiente: >= 40 e < 60',
            'Bom: >= 60 e < 80',
            'Ótimo: >= 80 e <= 85',
          ],
        },
        41: {
          numerador:
            'Total de procedimentos do tipo Tratamento Restaurador Atraumático.',
          denominador: 'Total de procedimentos restauradores.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 3',
            'Suficiente: > 3 e <= 6',
            'Bom: > 6 e <= 8',
            'Ótimo: > 8',
          ],
        },
        53: {
          numerador: 'Total de gestantes com atendimento odontológico.',
          denominador: 'Total de gestantes da equipe vinculada.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [],
        },
      }

      const indicador = nomesIndicadores[idIndicador]
      if (!indicador) return ''

      return {
        ...indicador,
        classificacao: indicador.classificacao.join('<br>'),
      }
    },

    linksCards(idIndicador) {
      const links = {
        46: '/mais-acesso-aps',
        51: '/desenvolvimento-infantil',
        52: '/gestantes-puerperas',
        48: '/pessoa-diabetes',
        50: '/pessoa-hipertensao',
        49: '/pessoa-idosa',
        47: '/saude-da-mulher',
        44: '/media-atendimentos-por-pessoa',
        45: '/acoes-interprofissionais',
        38: '/primeira-consulta-programada',
        43: '/tratamentos-concluidos',
        39: '/exodontias',
        42: '/escovacao-supervisionada',
        40: '/procedimentos-odonto-preventivos',
        41: '/tratamentos-restauradores-atramautico',
        53: '/saude-bucal-gestantes',
      }
      return links[idIndicador] || ''
    },
  },
}
</script>

<style scoped></style>
